import React, { useState, useEffect } from "react";

//import components
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";
import customToasts from "../../../assets/reusableComponents/myToasts";

//functions for datat fetching
import {
  caretaker,
  getAllProperties,
} from "../../../../redux/slices/sliceActions";
import { useSelector, useDispatch } from "react-redux";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

const AddRolesModal = ({ setShowModal, propertyToEdit }) => {
  //redux methods
  const dispatch = useDispatch();

  //navigation variables
  const [isCancelButtonHovered, setIsCancelButtonHovered] = useState(false);
  const [isNextButtonHovered, setIsNextButtonHovered] = useState(false);

  //role variables
  const choices = ["Caretaker", "Admin", "WatchMan"];
  const [selectedRole, setSelectedRole] = useState(choices[0]);
  const [roleTakersName, setRoleTakersName] = useState("");
  const [roleTakerEmail, setRoleTakerEmail] = useState("");
  const [roleTakerPhoneNumber, setRoleTakerPhoneNumber] = useState("");

  //methods
  const closeModal = () => {
    setShowModal(false);
  };

  const setNextStep = () => {
    const roleTakerDetails = {
      role_type: selectedRole.toLowerCase(),
      name: roleTakersName,
      email: roleTakerEmail,
      phone: roleTakerPhoneNumber,
    };

    customToasts.promise(
      dispatch(
        caretaker({
          newCaretaker: roleTakerDetails,
          propertyId: propertyToEdit?._id,
        })
      ).then((res) => {
        dispatch(getAllProperties());
        closeModal();
      }),
      {
        pending: "Assigning role...",
        success: "Role asignes successfully",
        error: "Failed to asign role",
      }
    );
  };

  //styles
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.7)", // Dark translucent overlay
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "white",
      padding: vh(20),
      borderRadius: vw(8),
      width: "90%", // Adapt to smaller screens
      maxWidth: vw(500),
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
      position: "relative",
      zIndex: 10000, // Ensure it's above the overlay
      animation: "fadeIn 0.3s ease",
      fontFamily: "Karla, sans-serif",
      overflowX: "hidden",
    },

    titles: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "center",
      marginBottom: vh(20),
    },
    mainTitle: {
      fontSize: vh(24),
      fontWeight: "700",
      marginBottom: vh(5),
    },
    subTitle: {
      fontSize: vh(16),
      fontWeight: "300",
      color: "#666",
    },

    propertyDescriptionDetails: {},
    propertyName: {
      position: "relative",
    },
    inputContainer: {
      display: "flex",
      justifyContent: "space-between",
      gap: vw(10),
    },
    input: {
      width: "100%",
      padding: vh(10),
      marginBottom: vh(10),
      borderRadius: vw(5),
      border: "1px solid #ccc",
      fontSize: vw(16),
    },
    select: {
      width: "100%",
      padding: vh(10),
      marginBottom:  vh(10),
      borderRadius: vw(5),
      border: "1px solid #ccc",
      fontSize: vw(16),
    },

    buttonsContainer: {
      marginTop:  vh(20),
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
    },
    cancelButton: {
      width: "50%",
      padding: vh(10),
      color: "white",
      borderRadius: vw(5),
      backgroundColor: "#B39359",
      border: "none",
      cursor: "pointer",
      marginRight: vw(10),
      transition: "background-color 0.3s ease",
    },
    cancelButtonHover: {
      backgroundColor: "#192A3A",
    },
    nextButton: {
      width: "50%",
      padding: vh(10),
      backgroundColor: "#192A3A",
      color: "white",
      borderRadius:vw(5),
      border: "none",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    nextButtonHover: {
      backgroundColor: "#B39359",
    },
  };

  return (
    <div style={styles.overlay} onClick={closeModal}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={styles.stepsSlider}>
          <div style={styles.individualStepContainer}>
            <div style={styles.titles}>
              <div style={styles.mainTitle}>Assign Roles (Optional)</div>
              <div style={styles.subTitle}>
                Enter Details for assigning roles and roletakers in the property
              </div>
            </div>
            <div style={styles.roleTakersDescriptionDetails}>
              <div>
                <label>Role Type</label>
                <DropdownSelect
                  choices={choices}
                  defaultChoice={selectedRole}
                  onSelect={(choice) => setSelectedRole(choice)}
                />
              </div>
              <div>
                <label>Role Taker name</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="e.g. John Doe"
                  value={roleTakersName}
                  onChange={(e) => setRoleTakersName(e.target.value)}
                />
              </div>
              <div>
                <label>Role Taker email</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="e.g. example@gmail.com"
                  value={roleTakerEmail}
                  onChange={(e) => setRoleTakerEmail(e.target.value)}
                />
              </div>
              <div>
                <label>Role Taker Phone Number</label>
                <input
                  style={styles.input}
                  type="text"
                  placeholder="e.g. +254 7234 578"
                  value={roleTakerPhoneNumber}
                  onChange={(e) => setRoleTakerPhoneNumber(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        <div style={styles.buttonsContainer}>
          <button
            style={{
              ...styles.cancelButton,
              ...(isCancelButtonHovered ? styles.cancelButtonHover : {}),
            }}
            onClick={closeModal}
            onMouseEnter={() => setIsCancelButtonHovered(true)}
            onMouseLeave={() => setIsCancelButtonHovered(false)}
          >
            Cancel
          </button>

          <button
            style={{
              ...styles.nextButton,
              ...(isNextButtonHovered ? styles.nextButtonHover : {}),
            }}
            onMouseEnter={() => setIsNextButtonHovered(true)}
            onMouseLeave={() => setIsNextButtonHovered(false)}
            onClick={() => {
              setNextStep();
            }}
          >
            Add
          </button>
        </div>
      </div>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Zoom}
      />
    </div>
  );
};

export default AddRolesModal;
